import PropTypes from 'prop-types';
import React from 'react';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames/bind';
import Formatter from 'yoda-core-components/lib/helpers/Formatter/Formatter';
import {
    ALTERNATE_PHONE_TITLE,
    SPL_DELIVERY_INST_TITLE,
    ABOUT_DELIVERY_TITLE,
    ABOUT_DELIVERY_DESC,
} from 'yoda-checkout-components/lib/common/Constants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './SilverAdditionalDeliveryMessage.css';

const cx = classNames.bind(styles);

function renderBodyHtml(items) {
    return map(items, (item) => {
        const description = isEmpty(item.description) ? '' : item.description;
        return (
            <div
                className={`${cx('additionalDeliveryMessageWrapper')} ${dt([
                    'leading-7',
                    'text-sm',
                    'first:pt-2',
                ])}`}
                data-automation-id="at-additional-delivery-msg-wrapper"
            >
                <div
                    className={dt(['font-open-sans-bold', 'text-black'])}
                    data-automation-id={`at-title-${item.title}`}
                >
                    {item.title}
                </div>
                <div className={cx('itemDesc')} data-automation-id={`at-desc-${item.title}`}>
                    {item.title === ABOUT_DELIVERY_TITLE ? (
                            <div dangerouslySetInnerHTML={{ __html: ABOUT_DELIVERY_DESC + description }} // eslint-disable-line
                        />
                    ) : (
                        description
                    )}
                </div>
            </div>
        );
    });
}

function SilverAdditionalDeliveryMessage({ shippingGroupDetails }) {
    const additionalDeliveryInfoList = [];
    if (isEmpty(shippingGroupDetails)) {
        return null;
    }
    if (shippingGroupDetails.address && shippingGroupDetails.address.secondaryPhone) {
        const alternatePhone = {
            title: ALTERNATE_PHONE_TITLE,
            description: Formatter.format(
                shippingGroupDetails.address.secondaryPhone,
                Formatter.TYPE.PHONE
            ),
        };
        additionalDeliveryInfoList.push(alternatePhone);
    }
    if (
        !isEmpty(shippingGroupDetails.instructions) &&
        shippingGroupDetails.instructions[0] &&
        shippingGroupDetails.instructions[0].message
    ) {
        const deliveryInstructionDescription =
            shippingGroupDetails.instructions[0].message === 'null'
                ? 'Not Provided'
                : shippingGroupDetails.instructions[0].message;
        const deliveryInstruction = {
            title: SPL_DELIVERY_INST_TITLE,
            description: deliveryInstructionDescription,
        };
        additionalDeliveryInfoList.push(deliveryInstruction);
    }
    if (
        !isEmpty(shippingGroupDetails.bagItems) &&
        shippingGroupDetails.bagItems[0] &&
        !isEmpty(shippingGroupDetails.bagItems[0].deliveryOptions) &&
        shippingGroupDetails.bagItems[0].deliveryOptions[0]
    ) {
        const deliveryDate =
            shippingGroupDetails.bagItems[0].deliveryOptions[0].estimatedDeliveryDate;
        const aboutDelivery = {
            title: ABOUT_DELIVERY_TITLE,
            description: deliveryDate,
        };
        additionalDeliveryInfoList.push(aboutDelivery);
    }

    return <div>{renderBodyHtml(additionalDeliveryInfoList)}</div>;
}

SilverAdditionalDeliveryMessage.propTypes = {
    shippingGroupDetails: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default SilverAdditionalDeliveryMessage;
